module.exports = __webpack_public_path__ + "img/Komite-Audit-Ainul-Hidayati.af6e318a.jpg";